import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
    const [chatState, setChatState] = useState({ open: false, data: null });

    const openChat = useCallback((row) => {
        setChatState({ open: true, data: row });
    }, []);

    const closeChat = useCallback(() => {
        setChatState({ open: false, data: null });
    }, []);

    return (
        <ChatContext.Provider value={{ chatState, openChat, closeChat }}>
            {children}
        </ChatContext.Provider>
    );
};

export const useChatContext = () => {
    const ctx = useContext(ChatContext);
    if (!ctx) return { chatState: { open: false, data: null }, openChat: () => {}, closeChat: () => {} };
    return ctx;
};
